/***
 * @file: å­å¸æå¡
 * @author: linkun.he
 * @Date: 2020-11-19 19:09:17
 */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';

import { SettingsService } from '@ithinkdt/shared/browser';
import { BaseAjaxService } from '@ithinkdt/shared/http';

@Injectable({
  providedIn: 'root',
})
export class DictionaryService extends BaseAjaxService {
  constructor(private httpClient: HttpClient, private settingsSrv: SettingsService) {
    super(httpClient);
  }
  // key: å­å¸pidï¼ value: æ¥å£è¿åå¼
  dictMap: Map<string | number, Map<string | number, string>> = new Map<string, Map<string | number, string>>();
  // key: å­å¸pidï¼ value: observer å®ä¾æ°ç»
  dictObsMap: Map<string, Observer<any>[]> = new Map<string, Observer<any>[]>();

  getDicListByDicCode(dicCode: any, ...args): Observable<any[]> {
    // å¤æ­è¯¥å­å¸pidæ¯å¦å·²ç»æ¥è¯¢è¿ï¼ å¦ææ¥è¯¢è¿ç´æ¥è§¦åè®¢éä¿¡æ¯
    if (this.dictMap.has(dicCode)) {
      return new Observable<any>((observer: Observer<any>) => {
        observer.next(this.dictMap.get(dicCode));
      });
    }

    // å¤æ­æ¯å¦å·²ç»è¿è¡è¯·æ±ï¼å¦ææ²¡æå¯¹å½åå­å¸pidè¿è¡è¯·æ±ï¼è¯·æ±ä¸æ¬¡
    if (!this.dictObsMap.has(dicCode)) {
      const dictServer = this.settingsSrv.userConfig.env.serverName.dict;
      this.post(`${dictServer}/cli/bus/dict/dictionary_list.do`, {
        dictType: dicCode,
        ...args,
      }).subscribe((res) => {
        // è¯·æ±ç»æä¹ååå­å°ç¼å­ä¸­
        this.dictMap.set(dicCode, res);
        // å¾ªç¯ç¼å­ä¸­çobserver ï¼è¿è¡è§¦å
        this.loopObs(dicCode);
      });
    }

    const obs = new Observable<any>((observer: Observer<any>) => {
      const obsList = this.dictObsMap.get(dicCode) || [];
      obsList.push(observer);
      this.dictObsMap.set(dicCode, obsList);
    });

    return obs;
  }

  /**
   * æ ¹æ®dictTypesè¿åå­å¸éå
   * @param dictTypes å­å¸ç±»åï¼ä»¥éå·éå¼ï¼å¦ï¼a,b,c
   * @returns Observable<any>
   */
  getDicListByDicCodes(dictTypes: string): Observable<any> {
    const dictServer = this.settingsSrv.userConfig.env.serverName.dict;
    return this.get(`${dictServer}/cli/bus/dict/dictionary_lists.do?dictTypes=${dictTypes}`);
  }

  /***
   * @description: è§¦åå·²ç¼å­çè®¢éå¯¹è±¡
   * @param dicCode å­å¸pid
   */
  private loopObs(dicCode: string): void {
    const obsList = this.dictObsMap.get(dicCode) || [];
    const res = this.dictMap.get(dicCode);
    obsList.forEach((obs) => {
      obs.next(res);
    });
    this.dictObsMap.delete(dicCode);
  }
}
